<script lang="ts" setup>
import { EvaluationRelevantInstance } from "types/EvaluationResults";

const props = defineProps({
  instance: {
    type: Object as PropType<EvaluationRelevantInstance>,
    required: true,
  },
  showHiddenCriteria: {
    type: Boolean,
    default: false,
  },
});

const documentId = inject("documentId") as any;

// todo: highight tokens
const highlightToken = () => {
  const positions = props.instance.tokens.map((token) => {
    const id = token.id;
    const position =
      useDocumentTokenIdPositionMapStore(documentId).tokenGlobalPositionFromId(
        id
      );

    return position;
  });

  useDocumentHighlightStore(documentId).setTokenPositionsToHighlight(positions);
};
</script>

<template>
  <div>
    <span class="mb-2 font-bold flex flex-row items-center">
      <span v-if="instance.details">
        <BasePopover>
          <BaseIconButton>
            <icon name="material-symbols:info" />
          </BaseIconButton>
          <template #content>
            <div class="flex flex-col p-1 max-w-[350px]">
              <span class="font-bold mb-1">
                {{ instance.details.type }}
              </span>
              <span>
                {{ instance.details.reason }}
              </span>
            </div>
          </template>
        </BasePopover>
      </span>
      <span class="shrink-0" @mouseenter="highlightToken">
        {{ instance.text }}
      </span>
      <span
        v-if="instance.problemDescription"
        class="flex flex-row items-center font-normal"
      >
        <span class="mx-2"> | </span>
        <span class="text-danger-default italic">
          {{ instance.problemDescription }}
        </span>
      </span>
    </span>
    <div v-if="instance.criteria" class="flex flex-col pl-4">
      <DocumentProblemReviewCriteriaItem
        v-for="(criteria, index) in instance.criteria"
        :key="index"
        :criteria="criteria"
        :show-hidden-criteria="showHiddenCriteria"
        class="mb-2"
      />
    </div>
  </div>
</template>

<style scoped></style>
